import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { AppService } from '../app.service';
import * as moment from 'moment';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-generate-graph',
  templateUrl: './generate-graph.component.html',
  styleUrls: ['./generate-graph.component.scss'],
  providers: [AppService]
})
export class GenerateGraphComponent implements OnChanges {

  @Input() data: any;
  @Input() title: string;
  @Input() isDataAvailable: boolean;
  @Input() dashboardType:string;
  respData: any = []
  errorData: boolean = false;
  public chartLabels:string[] =[];
  public chartType:string = 'line';
  public chartData:any[] = [];
  usfob: any[] = []
  tonnes: number[] = []
  public labels: string[] =[]
  fecha:string ='date'
  constructor(public appService: AppService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (this.data != null) {
      var reqdata = this.data;
      this.getGraphDataSubs(reqdata);
    }
  }

  /* method to call get-api from app.service */
  getGraphDataSubs(body) {
    this.isDataAvailable = false;
    try {
      this.appService.getGraphData(body)
        .subscribe(resp => {
          this.respData = resp;
          if (this.dashboardType==="liprices") {
            this.lipricesData();
          }
          else {
            this.processGraphData(body);
          }
          this.isDataAvailable = true;
        },
          error => {
            console.log(error, "error");
            this.errorData=true;
          })
    }

     catch (e) {
      console.log(e);
      this.errorData=true;
    }

  }

  processGraphData(body) {
    //console.log(body1, "body firebase");
    //let body = JSON.parse(body1);
    this.chartType=body.charttype;
    this.chartData = [{label: '', data:[], yAxisID: 'y-axis-1', }];
    this.labels =[]
    this.usfob = []
    this.tonnes = []
    var i=0;
    //Se diferencia entre Quarter, mes o año
    for (let entry of this.respData) {
      if (entry.month) {
        this.labels[i] = entry.year+"-"+entry.month;
      }
      else if (entry.quarter) {
        this.labels[i] = entry.year+" Q-"+entry.quarter;
      }
      else {
        this.labels[i] = entry.year;
      }
      this.usfob[i] = Math.round(entry.usfob/entry.tonnes);
      //this.usfob[i] = Number( entry.usfob.replace(/[^0-9,-]+/g,"").replace(",",".") ); //entry.usfob.replace(/[$.]+/g,"");
      this.tonnes[i] = Math.round(entry.tonnes);
      i=i+1;
    }
      this.chartData[0].lineTension=0;

    if (body.input==="tonnes") {
      this.chartData[0].label="Tonnes";
      this.chartData[0].data= this.tonnes;
      this.chartData[0].backgroundColor="#8ed7d7";
      this.chartData[0].hoverBackgroundColor="#3caaaa";
      this.chartData[0].borderColor="#3caaaa";
      this.chartData[0].hoverBorderColor="#3caaaa";
      this.chartData[0].pointBackgroundColor="#3caaaa";
      this.chartData[0].pointHoverBackgroundColor="#4BC0C0";
      this.chartData[0].pointHoverBorderColor="#3caaaa";
      this.chartOptions.scales.yAxes[0].scaleLabel.labelString = "Tonnes";
    }
    else  {
      this.chartData[0].data= this.usfob;
      this.chartData[0].label="US$FOB/Ton";
      this.chartOptions.scales.yAxes[0].scaleLabel.labelString = "US$FOB/Ton";
      this.chartData[0].backgroundColor="#74bff1";
      this.chartData[0].hoverBackgroundColor="#1586d1";
      this.chartData[0].borderColor="#1586d1";
      this.chartData[0].hoverBorderColor="#1586d1";
      this.chartData[0].pointBackgroundColor="#1586d1";
      this.chartData[0].pointHoverBackgroundColor="#1586d1";
      this.chartData[0].pointHoverBorderColor="#1586d1";
    }

  }

  // events on slice click
  public chartClicked(e:any):void {
    //console.log(e);
  }

  // event on pie chart slice hover
  public chartHovered(e:any):void {
    //console.log(e);
  }

  public chartOptions:any = {
    backgroundColor: '#FFCE56',
    responsive: true,
        scales: {
        yAxes: [{
          type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
          display: true,
          lineTension:0,
          scaleLabel: {
            display: true,
            labelString: 'Tonnes'
          },
          position: 'left',
          id: 'y-axis-1',
        }
         ],
      } };
      lipricesData() {

        this.chartType='line';
        this.chartData = [{label: '', data:[], yAxisID: 'y-axis-1', },{label: '', data:[], yAxisID: 'y-axis-1', }];
        this.labels =[]
        this.usfob = []
        var range: number[] = [];
        this.tonnes = []
        var i=0;
        //Se diferencia entre Quarter, mes o año
        for (let entry of this.respData) {
          if (entry.month) {
            this.labels[i] = entry.year+"-"+entry.month;
          }
          else if (entry.quarter) {
            this.labels[i] = entry.year+" Q-"+entry.quarter;
          }
          else {
            this.labels[i] = entry.year;
          }
          this.usfob[i] = Math.round (entry.usfob/entry.tonnes*1.1*0.95);
          range[i] = Math.round(entry.usfob/entry.tonnes *1.1*1.05);
          i=i+1;
        }
        console.log(this.chartData);
          this.chartData[0].lineTension=0;
          this.chartData[0].fill=false;

          this.chartData[0].data= this.usfob;
          this.chartData[0].label="MinPrice";

          this.chartData[1].lineTension=0;
          this.chartData[1].fill=false;
          this.chartData[1].data= range;
          this.chartData[1].label="MaxPrice";
          this.chartOptions.scales.yAxes[0].scaleLabel.labelString = "US$/Ton";
      }
}
